import React, { useEffect, useState, useContext } from "react";
import {
  Shimmer,
  ShimmerElementType,
  ThemeProvider,
  mergeStyles,
  mergeStyleSets,
  createTheme,
} from "@fluentui/react";
import themeContext from "../../../../context/theme/ThemeContext";

const ShimmerStudyList = () => {
  const {themeName} = useContext(themeContext);
  const [containerHeight, setContainerHeight] = useState(() => {
    const newScreenHeight = window.innerHeight;
    const monitorScreenHeightThreshold = 820;
      if (newScreenHeight >= monitorScreenHeightThreshold) {
        return "60vh";
      } else {
        return "45vh";
      }
  });

  const classNames = mergeStyleSets({
    wrapper: {
      selectors: {
        "& > .ms-Shimmer-container": {
          padding: "10px 10px",
        },
      },
      background: themeName != "light"?"#040910":"white",
      boxSizing:'border-box'
    },
  });

  const classRowNames = mergeStyleSets({
    wrapper: {
      background: themeName != "light"?"#040910":"white",
      height:'40vh',
      overflow:'auto'
    },
  });

  const customThemeForShimmer = createTheme({
    body: {
      background: "red",
    },
    palette: {
      // palette slot used in Shimmer for main background
      neutralLight: "rgb(103, 102, 102)",
      // palette slot used in Shimmer for tip of the moving wave
      neutralLighter: "rgb(70, 70, 70)",
      // palette slot used in Shimmer for all the space around the shimmering elements
      white: "#0078D4",
    },
  });

  const customThemeForRowShimmer = createTheme({
    body: {
      background: "red",
    },
    palette: {
      // palette slot used in Shimmer for main background
      neutralLight: "rgb(103, 102, 102)",
      // palette slot used in Shimmer for tip of the moving wave
      neutralLighter: "rgb(70, 70, 70)",
      // palette slot used in Shimmer for all the space around the shimmering elements
      white: "#0078D4",
    },
  });

  const getShimmerStyles = () => {
    return {
      shimmerWrapper: [{}],
      shimmerLine: [
        {
          borderRadius: "10px !important",
        },
      ],
      shimmerGap: [
        {
          borderRadius: "7px !important",
          backgroundColor: "red !important",
        },
      ],
    };
  };

  const getShimmerRowStyles = () => {
    return {
      shimmerWrapper: [{}],
      shimmerLine: [
        {
          borderRadius: "10px !important",
        },
      ],
      shimmerGap: [
        {
          borderRadius: "7px !important",
          backgroundColor: "red !important",
        },
      ]
    };
  };

  const shimmerSortFilterSection = [
    { type: ShimmerElementType.line, width: "6%", height: 30 },
    { type: ShimmerElementType.gap, width: "1%", height: 30 },

    { type: ShimmerElementType.line, width: "20%", height: 30 },
    { type: ShimmerElementType.gap, width: "1%", height: 30 },

    { type: ShimmerElementType.line, width: "6%", height: 30 },
    { type: ShimmerElementType.gap, width: "1%", height: 30 },

    { type: ShimmerElementType.line, width: "10%", height: 30 },
    { type: ShimmerElementType.gap, width: "1%", height: 30 },

    { type: ShimmerElementType.line, width: "10%", height: 30 },
    { type: ShimmerElementType.gap, width: "1%", height: 30 },

    { type: ShimmerElementType.line, width: "8%", height: 30 },
    { type: ShimmerElementType.gap, width: "60%", height: 30 },

    { type: ShimmerElementType.line, width: "5%", height: 30 },
    { type: ShimmerElementType.gap, width: "2%", height: 30 },
    { type: ShimmerElementType.line, width: "5%", height: 30 },
  ];

  const shimmerTabSection = [
    { type: ShimmerElementType.line, width: "8%", height: 30 },
    { type: ShimmerElementType.gap, width: "1%", height: 30 },

    { type: ShimmerElementType.line, width: "8%", height: 30 },
    { type: ShimmerElementType.gap, width: "1%", height: 30 },

    { type: ShimmerElementType.line, width: "8%", height: 30 },
    { type: ShimmerElementType.gap, width: "1%", height: 30 },

    { type: ShimmerElementType.line, width: "8%", height: 30 },
    { type: ShimmerElementType.gap, width: "1%", height: 30 },

    { type: ShimmerElementType.line, width: "8%", height: 30 },
    { type: ShimmerElementType.gap, width: "1%", height: 30 },

    { type: ShimmerElementType.line, width: "8%", height: 30 },
    { type: ShimmerElementType.gap, width: "1%", height: 30 },

    { type: ShimmerElementType.gap, width: "30%", height: 30 },

    { type: ShimmerElementType.line, width: "6%", height: 30 },
    { type: ShimmerElementType.gap, width: "1%", height: 30 },

    { type: ShimmerElementType.line, width: "6%", height: 30 },
    { type: ShimmerElementType.gap, width: "1%", height: 30 },

    { type: ShimmerElementType.line, width: "6%", height: 30 },
  ];

  const shimmerSubTabSection = [
    { type: ShimmerElementType.line, width: "8%", height: 20 },
    { type: ShimmerElementType.gap, width: "1%", height: 20 },

    { type: ShimmerElementType.line, width: "8%", height: 20 },
    { type: ShimmerElementType.gap, width: "1%", height: 20 },

    { type: ShimmerElementType.line, width: "8%", height: 20 },
    { type: ShimmerElementType.gap, width: "1%", height: 20 },

    { type: ShimmerElementType.line, width: "8%", height: 20 },
    { type: ShimmerElementType.gap, width: "80%", height: 20 },
  ];

  const shimmerTableHeaders = [
    { type: ShimmerElementType.circle, width: "2%", height: 40 },
    { type: ShimmerElementType.gap, width: "3%" },

    { type: ShimmerElementType.line, width: "20%", height: 40 },
    { type: ShimmerElementType.gap, width: "4%" },

    { type: ShimmerElementType.line, width: "20%", height: 40 },
    { type: ShimmerElementType.gap, width: "4%" },

    { type: ShimmerElementType.line, width: "20%", height: 40 },
    { type: ShimmerElementType.gap, width: "4%" },

    { type: ShimmerElementType.line, width: "20%", height: 40 },
    { type: ShimmerElementType.gap, width: "4%" },

    { type: ShimmerElementType.line, width: "20%", height: 40 },
    { type: ShimmerElementType.gap, width: "4%" },

    { type: ShimmerElementType.line, width: "20%", height: 40 },
    { type: ShimmerElementType.gap, width: "0%" },
  ];

  const shimmerTableRows = [
    { type: ShimmerElementType.line, width: "100%", height: 100 },
  ];

  return (
    <>
     <div className="study-list-main-container">
      <ThemeProvider theme={customThemeForShimmer}>
        <div className={classNames.wrapper}>
          <Shimmer
            shimmerColors={{
              background: themeName != "light"?"#040910":"white",
            }}
            styles={getShimmerStyles()}
            shimmerElements={shimmerSortFilterSection}
          />
          <div
            style={{ marginBottom: "10px" }}
          ></div>
          <Shimmer
            shimmerColors={{
              background: themeName != "light"?"#040910":"white",
            }}
            styles={getShimmerStyles()}
            shimmerElements={shimmerTabSection}
          />
          <div style={{ marginBottom: "10px" }}></div>
          <Shimmer
            shimmerColors={{
              background: themeName != "light"?"#040910":"white",
            }}
            styles={getShimmerStyles()}
            shimmerElements={shimmerSubTabSection}
          />
          <div
            style={{ borderTop: "1px solid #201f1e", marginBottom: "10px" }}
          ></div>
          <Shimmer
            shimmerColors={{
              background: themeName != "light"?"#040910":"white",
            }}
            styles={getShimmerStyles()}
            shimmerElements={shimmerTableHeaders}
          />
          <div
            style={{ borderTop: "1px solid #201f1e", marginBottom: "10px" }}
          ></div>
          <ThemeProvider theme={customThemeForRowShimmer}>
          <div 
          className={`${classRowNames.wrapper} study-list-modal-scroll`}
          style={{ padding: '10px 5px 10px 5px', height: containerHeight }}
          >
            <Shimmer
              shimmerColors={{
                background: themeName != "light"?"#040910":"white",
              }}
              styles={getShimmerRowStyles()}
              shimmerElements={shimmerTableRows}
            />
            <div style={{ marginBottom: "20px" }}></div>
            <Shimmer
              shimmerColors={{
                background: themeName != "light"?"#040910":"white",
              }}
              styles={getShimmerRowStyles()}
              shimmerElements={shimmerTableRows}
            />
            <div style={{ marginBottom: "20px" }}></div>
            <Shimmer
              shimmerColors={{
                background: themeName != "light"?"#040910":"white",
              }}
              styles={getShimmerRowStyles()}
              shimmerElements={shimmerTableRows}
            />
            <div style={{ marginBottom: "20px" }}></div>
             <Shimmer
              shimmerColors={{
                background: themeName != "light"?"#040910":"white",
              }}
              styles={getShimmerRowStyles()}
              shimmerElements={shimmerTableRows}
            />
            <div style={{ marginBottom: "20px" }}></div>
             <Shimmer
              shimmerColors={{
                background: themeName != "light"?"#040910":"white",
              }}
              styles={getShimmerRowStyles()}
              shimmerElements={shimmerTableRows}
            />
            </div>
          </ThemeProvider>
        </div>
      </ThemeProvider>
      </div>
    </>
  );
};

export default ShimmerStudyList;
